import gql from "graphql-tag";

export const MY_HR_GET_IMPORT_EMPLOYEE_LIST = gql`
  query importEmployeeList(
    $page: Int!
    $pageSize: Int!
    $searchField: String
    $searchText: String
    $contracts: [String]
    $product: String!
    $role: String!
  ) {
    importEmployeeList(
      page: $page
      pageSize: $pageSize
      searchField: $searchField
      searchText: $searchText
      contracts: $contracts
      product: $product
      role: $role
    ) {
      page
      pageSize
      total
      totalPages
      availableList {
        _id
        code
        name
      }
      selectedList {
        _id
        code
        name
      }
    }
  }
`;
